// extracted by mini-css-extract-plugin
export default {"container":"styles_container__OB6ad","title":"styles_title__Vl23h"};